module.exports = __webpack_public_path__ + "img/anti-oxidant.b6ee69be.jpg";